const allAdjustmentTableData = { data: [], loading: true };
export const GetAllGeneralAdjTableRed = (state = allAdjustmentTableData, action) => {
  switch (action.type) {
    case "get_alladjustmenttabledata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
